import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App.js'
import { legacyHashTarget } from './domain/legacy-hash.js'
import { rememberedSiteId } from './workspace/site.js'
import { applyThemeMode, readThemeMode } from './shell/preferences.js'
import './styles.css'

// Addresses from before 0.8.0 lived after a `#` (`/#/contents/abc`): they are
// in bookmarks and in the gateway's own sign-in redirects. Rewritten in place,
// before the router reads the location, so nothing that worked stops working.
const legacy = legacyHashTarget(window.location.hash, rememberedSiteId())
if (legacy) window.history.replaceState(null, '', legacy)

// Before the first paint, so a dark-mode person never sees a white flash.
applyThemeMode(readThemeMode())

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('#root element not found in index.html.')

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
